<template>
    <div>
        <Menu
            :menuOptions="options"
            ref="menuRef"
            menuOptionsWrapperClasses="py-1 border border-won-gray-light rounded flex flex-col gap-1"
        >
            <template #menuButton>
                <div class="flex items-center gap-1 w-fit">
                    <span
                        class="text-base text-won-dark font-medium"
                    >
                        {{ displayMap[selectedValue] }}
                    </span>
                    
                    <ChevronDownIcon
                        class="size-4 text-won-dark-blue"
                    />
                </div>
            </template>
            
            <template #menuItem="{ option }">
                <button
                    class="
                        flex items-center px-2.5 gap-2.5 py-1 w-full disabled:opacity-50
                    "
                    :class="option?.disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-won-bg-blue'"
                    @click="() => updateUserPermissionHandler(option?.value)"
                    :disabled="option?.disabled"
                >
                    <span class="size-4">
                        <CheckIcon
                            v-if="selectedValue === option.value"
                            class="size-4 text-won-green"
                        />
                    </span>
                    
                    <span class="text-base">
                        {{ option?.actionText }}
                    </span>
                </button>
            </template>
        </Menu>
    </div>
</template>

<script setup>
import { ref, toRefs } from 'vue'

import Menu from "../library/menu.vue";

import { CheckIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";

const emit = defineEmits(['change']);
const props = defineProps({
    options: {
        type: Array,
        default: []
    },
    displayMap: {
        type: Object,
        default: {}
    }
})
const { options, displayMap } = toRefs(props);

const selectedValue = defineModel();
const menuRef = ref(null);

const updateUserPermissionHandler = (newPermission) => {
    selectedValue.value = newPermission;
}
</script>
